
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";

import { appApiResources } from '../../../configuration/app.constants';

@Injectable({
  providedIn: 'root'
})
export class GetCountryStateCityService {

  constructor(private http: HttpClient) { }

  async getAll() {
    try {
      let response = await this.http
        .get("https://raw.githubusercontent.com/dr5hn/countries-states-cities-database/master/countries%2Bstates%2Bcities.json")
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  async getAllCountry() {
    try {
      let response = await this.http
        .get(`${appApiResources.getAllCountry}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  getAllCountrySub() {
    return this.http.get(`${appApiResources.getAllCountry}`)
  }

  async getAllState(ID) {
    try {
      let response = await this.http
        .get(`${appApiResources.getAllCountry}?country_id=${ID}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  getAllStateSub(ID) {
    return this.http
      .get(`${appApiResources.getAllCountry}?country_id=${ID}`)
  }

  async getAllCity(countryID, stateID) {
    try {
      let response = await this.http
        .get(`${appApiResources.getAllCountry}?country_id=${countryID}&state_id=${stateID}`)
        .toPromise();
      return response;
    } catch (error) {
      return error;
    }
  }

  getAllCitySub(countryID, stateID) {
    return this.http
      .get(`${appApiResources.getAllCountry}?country_id=${countryID}&state_id=${stateID}`)

  }

}